// Admin translations - English
export const en = {
  // Auth
  "admin_panel": "Admin Panel",
  "setup_admin": "Create Admin Account",
  "admin_login": "Admin Login",
  "email": "Email",
  "password": "Password",
  "confirm_password": "Confirm Password",
  "login": "Login",
  "logout": "Logout",
  "setup": "Create Account",
  "office_email_only": "Only office@neuro-mesh.io can be admin",
  "password_requirements": "Password must be at least 14 characters with uppercase, lowercase, number, and special character",
  
  // Navigation
  "dashboard": "Dashboard",
  "users": "Users",
  "analytics": "Analytics",
  "export": "Export Center",
  "system_health": "System Health",
  
  // Dashboard
  "overview": "Overview",
  "total_users": "Total Users",
  "users_7d": "Users (7d)",
  "users_today": "Users Today",
  "total_sessions": "Total Sessions",
  "sessions_7d": "Sessions (7d)",
  "cerebro_events": "Cerebro Events",
  "robomesh_events": "RoboMesh Events",
  "visits_over_time": "Visits Over Time",
  "mode_split": "Mode Usage Split",
  
  // Users
  "user_list": "User List",
  "search_users": "Search users...",
  "name": "Name",
  "provider": "Provider",
  "created_at": "Created",
  "last_active": "Last Active",
  "sessions": "Sessions",
  "actions": "Actions",
  "view_details": "View Details",
  
  // Analytics
  "event_types": "Event Types",
  "mode_usage": "Mode Usage",
  "last_30_days": "Last 30 Days",
  
  // Export
  "export_data": "Export Data",
  "export_users": "Export Users",
  "export_sessions": "Export Sessions",
  "format": "Format",
  "csv": "CSV",
  "json": "JSON",
  "download": "Download",
  
  // System Health
  "recent_events": "Recent Events",
  "recent_audit_logs": "Recent Audit Logs",
  "database_stats": "Database Stats",
  "status": "Status",
  "healthy": "Healthy",
  
  // Common
  "loading": "Loading...",
  "error": "Error",
  "success": "Success",
  "page": "Page",
  "of": "of",
  "no_data": "No data available",
  "language": "Language",
  "english": "English",
  "chinese": "中文",
  "german": "Deutsch"
};
